import { render, staticRenderFns } from "./userFeedbackList.vue?vue&type=template&id=15ce4756&scoped=true&"
import script from "./userFeedbackList.vue?vue&type=script&lang=js&"
export * from "./userFeedbackList.vue?vue&type=script&lang=js&"
import style0 from "./userFeedbackList.vue?vue&type=style&index=0&id=15ce4756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ce4756",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15ce4756')) {
      api.createRecord('15ce4756', component.options)
    } else {
      api.reload('15ce4756', component.options)
    }
    module.hot.accept("./userFeedbackList.vue?vue&type=template&id=15ce4756&scoped=true&", function () {
      api.rerender('15ce4756', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/userFeedback/userFeedbackList.vue"
export default component.exports